"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class LocateMe {
    constructor(provider, callback) {
        this.callback = callback;
        this.provider = provider;
        this.errors = {
            1: "Permission denied",
            2: "Position unavailable",
            3: "Request timeout",
        };
    }
    onSuccess(position) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.provider.reverseGeocode(position.coords.latitude, position.coords.longitude);
            const storableResult = yield this.provider.resultSelected(result);
            this.callback(storableResult);
        });
    }
    onError(error) {
        return this.errors[error.code];
    }
    perform() {
        const timeout = 1000 * 60; // Wait for one minute
        navigator.geolocation.getCurrentPosition(this.onSuccess.bind(this), this.onError.bind(this), {
            enableHighAccuracy: true,
            timeout,
        });
    }
}
exports.default = LocateMe;
